module.exports = require('./dropbox-team').DropboxTeam;
